import { TCypher } from "../types"
import { get, post } from "./axiosClient"

export type SendCodeProps = {
    code: string,
    token: string
}

export type SendCodeResponse = {
    sucessMessage?: string,
    errorMessage?: string
}

const sendCode = async (code: string, token: string, path: string): Promise<SendCodeResponse> => {
    return await post({
        data: {},
        params: {code : code},
        path: path,
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { sucessMessage: res.data }
            
        } else if (res.status === 400) {
            return {errorMessage: res.data}
        } else {
            return { errorMessage: 'Došlo k nečekané chybě :(' }
        }
    })
}

export const sendCypherCode = async ({ code, token }: SendCodeProps): Promise<SendCodeResponse> => {
    return sendCode(code, token, 'websystem/cypher')
}

export const sendBonusCode = async ({ code, token }: SendCodeProps): Promise<SendCodeResponse> => {
    return sendCode(code, token, 'websystem/bonus')
}

export const sendStartCode = async ({ code, token }: SendCodeProps): Promise<SendCodeResponse> => {
    return sendCode(code, token, 'websystem/start')
}